module.exports = __webpack_public_path__ + "static/img/head.1d9d39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/limit-activity/head.png
// module id = 6TDb
// module chunks = 215